import { payLoadAddDiscount } from "./discountsModel";

export interface DiscountById {
  id: number;
  created_at: string;
  updated_at: string;
  deleted_at: string | null;
  name: string;
  percentage: number;
  from_date: string;
  end_date: string;
}

export interface PayLoadEditDiscount extends payLoadAddDiscount {
  id: number;
}

export interface DiscountFormValues {
  name: string;
  percentage: number;
  from_date: string;
  end_date: string;
}

export const transformDiscountToFormValues = (
  discount: DiscountById
): DiscountFormValues => {
  return {
    name: discount.name,
    percentage: Number(discount.percentage),
    from_date: new Date(discount.from_date).toISOString().split('T')[0],
    end_date: new Date(discount.end_date).toISOString().split('T')[0]
  };
};
